<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">اسم الخدمة - عربي:</label>
          <div>{{ name }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">اسم الخدمة - انجليزي:</label>
          <div class="english-input">{{ nameEn }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <div class="form-check">
            <label class="form-check-label" for="hasHandPrice">
              <i v-if="hasHandPrice" class="fa-regular fa-circle-check"></i>
              <i v-else class="fa-regular fa-circle-xmark"></i>
              يستطيع المزود إضافة قيمة شغل اليد
            </label>
          </div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <div class="form-check">
            <label class="form-check-label" for="hasPartsPrice">
              <i v-if="hasPartsPrice" class="fa-regular fa-circle-check"></i>
              <i v-else class="fa-regular fa-circle-xmark"></i>
              يستطيع المزود إضافة قيمة قطع الغيار
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <div class="form-check">
            <label class="form-check-label" for="isPhoto">
              <i v-if="isPhoto" class="fa-regular fa-circle-check"></i>
              <i v-else class="fa-regular fa-circle-xmark"></i>
              خدمة مخصصة لتصوير العقارات
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">نوع الخدمة (التصنيف):</label>
          <div>
            <span class="badge" :class="categoryBadgeClass(category)">
              {{ categoryLabel }}
            </span>
          </div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label">الحالة:</label>
          <div>
            {{ isActive ? 'نشط' : 'غير نشط' }}
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
export default {
  name: 'ServicesView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      name: null,
      nameEn: null,
      price: 0,
      priceFast: 0,
      isActive: true,
      isPhoto: false,
      hasHandPrice: true,
      hasPartsPrice: true,
      category: null,
    }
  },
  methods: {
    categoryBadgeClass(cat) {
      return {
        normal: 'bg-info text-dark',
        fast: 'bg-warning text-dark',
        mosque: 'bg-success',
        global: 'bg-primary',
      }[cat] || 'bg-secondary';
    },
  },
  computed: {
    categoryLabel() {
      const map = {
        normal: 'صيانة عادية',
        fast: 'صيانة سريعة',
        mosque: 'بيوت الله صيانة',
        global: 'صيانة شاملة',
      };
      return map[this.category] || this.category;
    },
  },
  created(){
    if(this.dataRow){
      this.name = this.dataRow.name;
      this.nameEn = this.dataRow.nameEn;
      this.price = this.dataRow.price;
      this.priceFast = this.dataRow.priceFast;
      this.isActive = this.dataRow.isActive;
      this.isPhoto = this.dataRow.isPhoto;
      this.hasHandPrice = this.dataRow.hasHandPrice;
      this.hasPartsPrice = this.dataRow.hasPartsPrice;
      this.category = this.dataRow.category ?? 'normal';
    }
  }
}
</script>
